import axios from "axios";

export type MachineType = {
  name: string;
  cpus: number;
  memory: number;
  gpu: number;
  gpuMemory: number;
  chargePerHour: number;
};

type ApiMachineType = {
  name: string;
  cpus: number;
  memory: number;
  gpu: number;
  gpu_memory: number;
  charge_per_hour: number;
};

// Create axios instance
const api = axios.create({
  baseURL: process.env.NEXT_PUBLIC_BACKEND_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Fallback machine types in case API fails
const fallbackMachineTypes: MachineType[] = [
  {
    name: "m6a.2xlarge",
    cpus: 8,
    memory: 32,
    gpu: 0,
    gpuMemory: 0,
    chargePerHour: 1.0,
  },
  {
    name: "g5.2xlarge",
    cpus: 8,
    memory: 32,
    gpu: 1,
    gpuMemory: 24,
    chargePerHour: 2.0,
  },
];

let cachedMachineTypes: MachineType[] | null = null;

export async function fetchMachineTypes(): Promise<MachineType[]> {
  if (cachedMachineTypes) {
    return cachedMachineTypes;
  }

  try {
    const { data } = await api.get<ApiMachineType[]>("/hosted_instances");

    // Transform the API response to match our types
    cachedMachineTypes = data.map(machine => ({
      name: machine.name,
      cpus: machine.cpus,
      memory: machine.memory,
      gpu: machine.gpu,
      gpuMemory: machine.gpu_memory,
      chargePerHour: machine.charge_per_hour,
    }));

    return cachedMachineTypes;
  } catch (error) {
    console.error("Error fetching machine types:", error);
    return fallbackMachineTypes;
  }
}

// For backwards compatibility, export a promise that resolves to the machine types
export const machineTypes = fetchMachineTypes();

// Helper functions
// export const getMachineSpec = (machineType: MachineType): MachineSpec => {
//   return machineTypes[machineType];
// };
//
// export const hasGPU = (machineType: MachineType): boolean => {
//   return machineTypes[machineType].gpu > 0;
// };
//
// export const getHourlyCharge = (machineType: MachineType): number => {
//   return machineTypes[machineType].chargePerHour;
// };
